import 'dotenv/config';
import { gasStation } from '../gasStation';
import { iconAstron, iconStability, iconXDC, iconEthereum, iconPolygon } from '../static/icons';

var CHAIN_ID = /* @__PURE__ */ ((CHAIN_ID2) => {
  CHAIN_ID2["local"] = "1337";
  CHAIN_ID2["mainnet"] = "1";
  CHAIN_ID2["matic"] = "137";
  CHAIN_ID2["amoy"] = "80002";
  CHAIN_ID2["sepolia"] = "11155111";
  CHAIN_ID2["xdc"] = "50";
  CHAIN_ID2["xdcapothem"] = "51";
  CHAIN_ID2["stabilitytestnet"] = "20180427";
  CHAIN_ID2["stability"] = "101010";
  CHAIN_ID2["astron"] = "1338";
  CHAIN_ID2["astrontestnet"] = "21002";
  return CHAIN_ID2;
})(CHAIN_ID || {});
const SUPPORTED_CHAINS = {
  ["1337" /* local */]: {
    id: "1337" /* local */,
    label: "Local",
    name: "local",
    type: "development",
    currency: "ETH",
    iconImage: iconEthereum,
    explorerUrl: "https://localhost/explorer",
    rpcUrl: "http://localhost:8545"
  },
  ["1" /* mainnet */]: {
    id: "1" /* mainnet */,
    label: "Mainnet",
    name: "mainnet",
    type: "production",
    currency: "ETH",
    iconImage: iconEthereum,
    explorerUrl: "https://etherscan.io",
    rpcUrl: `https://mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`
  },
  ["137" /* matic */]: {
    id: "137" /* matic */,
    label: "Polygon",
    name: "matic",
    type: "production",
    currency: "MATIC",
    iconImage: iconPolygon,
    explorerUrl: "https://polygonscan.com",
    rpcUrl: `https://polygon-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`,
    gasStation: gasStation("https://gasstation.polygon.technology/v2"),
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18
    }
  },
  ["80002" /* amoy */]: {
    id: "80002" /* amoy */,
    label: "Polygon Amoy",
    name: "amoy",
    type: "test",
    currency: "MATIC",
    iconImage: iconPolygon,
    explorerUrl: "https://www.oklink.com/amoy",
    explorerApiUrl: `https://www.oklink.com/${process.env.OKLINK_API_KEY}`,
    rpcUrl: `https://polygon-amoy.infura.io/v3/${process.env.INFURA_API_KEY}`,
    gasStation: gasStation("https://gasstation.polygon.technology/amoy"),
    nativeCurrency: {
      name: "MATIC",
      symbol: "aMATIC",
      decimals: 18
    }
  },
  ["11155111" /* sepolia */]: {
    id: "11155111" /* sepolia */,
    label: "Sepolia",
    name: "sepolia",
    type: "test",
    currency: "ETH",
    iconImage: iconEthereum,
    explorerUrl: "https://sepolia.etherscan.io",
    rpcUrl: `https://sepolia.infura.io/v3/${process.env.INFURA_API_KEY}`,
    nativeCurrency: {
      name: "ETH",
      symbol: "sepETH",
      decimals: 18
    }
  },
  ["50" /* xdc */]: {
    id: "50" /* xdc */,
    label: "XDC Network",
    name: "xdc",
    type: "production",
    currency: "XDC",
    iconImage: iconXDC,
    explorerUrl: "https://xdcscan.io",
    rpcUrl: "https://rpc.ankr.com/xdc",
    nativeCurrency: {
      name: "XDC",
      symbol: "XDC",
      decimals: 18
    }
  },
  ["51" /* xdcapothem */]: {
    id: "51" /* xdcapothem */,
    label: "Apothem Network",
    name: "xdcapothem",
    type: "test",
    currency: "XDC",
    iconImage: iconXDC,
    explorerUrl: "https://apothem.xdcscan.io",
    rpcUrl: "https://rpc.ankr.com/xdc_testnet",
    nativeCurrency: {
      name: "XDC",
      symbol: "XDC",
      decimals: 18
    }
  },
  ["20180427" /* stabilitytestnet */]: {
    id: "20180427" /* stabilitytestnet */,
    label: "Stability Testnet Network",
    name: "stabilitytestnet",
    type: "test",
    currency: "FREE",
    iconImage: iconStability,
    explorerUrl: "https://stability-testnet.blockscout.com/",
    rpcUrl: `https://rpc.testnet.stabilityprotocol.com/zgt/${process.env.STABILITY_TESTNET_API_KEY}`,
    gasStation: gasStation("https://rpc.testnet.stabilityprotocol.com/gas-station"),
    nativeCurrency: {
      name: "FREE",
      symbol: "FREE",
      decimals: 18
    }
  },
  ["101010" /* stability */]: {
    id: "101010" /* stability */,
    label: "Stability Network",
    name: "stability",
    type: "production",
    currency: "FREE",
    iconImage: iconStability,
    explorerUrl: "https://stability.blockscout.com/",
    rpcUrl: `https://rpc.stabilityprotocol.com/zgt/${process.env.STABILITY_API_KEY}`,
    gasStation: gasStation("https://rpc.stabilityprotocol.com/gas-station"),
    nativeCurrency: {
      name: "FREE",
      symbol: "FREE",
      decimals: 18
    }
  },
  ["1338" /* astron */]: {
    id: "1338" /* astron */,
    label: "Astron Network",
    name: "astron",
    type: "production",
    currency: "ASTRON",
    iconImage: iconAstron,
    explorerUrl: "https://astronscanl2.bitfactory.cn/",
    rpcUrl: `https://astronlayer2.bitfactory.cn/rpc/`,
    gasStation: gasStation("https://astronscanl2.bitfactory.cn/gas-station"),
    nativeCurrency: {
      name: "ASTRON",
      symbol: "ASTRON",
      decimals: 18
    }
  },
  ["21002" /* astrontestnet */]: {
    id: "21002" /* astrontestnet */,
    label: "Astron Testnet Network",
    name: "astrontestnet",
    type: "test",
    currency: "ASTRON",
    iconImage: iconAstron,
    explorerUrl: "https://dev-astronscanl2.bitfactory.cn/",
    rpcUrl: `https://dev-astronlayer2.bitfactory.cn/query/`,
    gasStation: gasStation("https://dev-astronscanl2.bitfactory.cn/gas-station"),
    nativeCurrency: {
      name: "ASTRONTEST",
      symbol: "ASTRONTEST",
      decimals: 18
    }
  }
};

export { CHAIN_ID, SUPPORTED_CHAINS };
